import { CUSTOM_ELEMENTS_SCHEMA, Component, EventEmitter, Input, Output } from "@angular/core";
import { CDN_IMAGES } from "src/constants/param-constants";

@Component({
  selector: 'upsell-header',
  templateUrl: './upsell-header.html',
  styleUrls: ['./upsell-header.scss'],
})
export class UpsellHeaderComponent {
  @Input() icon: string = CDN_IMAGES.LOGO_WHITE;
  @Input() braintreeDefaultCountry: string = 'United States';

  //Provide external method to navigate to next page over funnel
  @Output() nextPageEvent = new EventEmitter();

  PHONE = CDN_IMAGES.PHONE;
  window: any = window;
  isToggledOff: boolean = true;

  constructor() {}

  nextPage(page: any) {
    this.nextPageEvent.emit(page);
  }
}